module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-arrow-down-d9e61c59.svg";